export default "__VITE_ASSET__Dlcye7Jf__"